import React, { useEffect, useRef, useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  CloseIcon,
  NotificationGreyIcon,
  NotificationRedIcon,
} from "../../assets/images";
import SchedulingNotification from "./SchedulingNotification";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { resetSession } from "../../redux/auth";
import { GetSchedulingNotificationCountPayloadType } from "../../commonTypes/notificationType";
import {
  getSchedulingNotificationCountAction,
  resetNotificationCount,
  resetNotificationError,
  resetNotificationStatusCode,
  resetNotificationSuccess,
  resetScheduleNotificationCount,
} from "../../redux/notification";
import { ErrorSuccessModal } from "../../components/commons";
import "./scrollbar.scss";
import { Toaster } from "react-hot-toast";

type AppProps = {
  history: any;
  token: null | string;
  success: number | null;
  statusCode: number | null;
  error: string | null | undefined;
  // notificationCount: any;
  notificationCount: number;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetNotificationStatusCode: () => void;
  dispatchResetNotificationSuccess: () => void;
  dispatchResetScheduleNotificationCount: () => void;
  dispatchGetSchedulingNotificationCountAction: (
    data: GetSchedulingNotificationCountPayloadType
  ) => void;
  dispatchResetNotificationCount: () => void;
};
const Notification = ({
  history,
  token,
  success,
  statusCode,
  error,
  notificationCount,
  // notificationCount,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetNotificationStatusCode,
  dispatchResetNotificationSuccess,
  dispatchResetScheduleNotificationCount,
  dispatchGetSchedulingNotificationCountAction,
  dispatchResetNotificationCount
}: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [notificationDivWidth, setNotificationDivWidth] =
    useState<boolean>(false);
  const notificationMountedRef = useRef<boolean>(true);
  useEffect(() => {
    dispatchResetError();
    dispatchResetNotificationSuccess();
    dispatchResetNotificationStatusCode();
    // dispatchResetScheduleNotificationCount()
    const finalData = {
      token,
    };
    // dispatchGetSchedulingNotificationCountAction(finalData);
  }, []);

  useEffect(()=>{
    if(isOpen){
      dispatchResetNotificationCount()
    }
  },[isOpen])
  useEffect(() => {
    if (!notificationMountedRef.current && notificationCount > 0) {
      // showNotification();
    } else {
      notificationMountedRef.current = false;
    }
  }, [notificationCount]);

  useEffect(() => {
    if (notificationCount) {
      setNotificationDivWidth(true);
    }
    setTimeout(() => {
      setNotificationDivWidth(false);
    }, 3000);
  }, [notificationCount]);

  // useEffect(() => {
  //   let delayDebounceFn: any = null;
  //   if (!error) {
  //     delayDebounceFn = setTimeout(() => {
  //       fetchNotificationCountData();
  //     }, 30000);
  //   }

  //   return () => clearTimeout(delayDebounceFn);
  // });

  const showNotification = () => {
    if ((window as any).Notification.permission === "granted") {
      new (window as any).Notification("Hello", {
        body: "You got new scheduling Notification",
      });
    } else if ((window as any).Notification.permission !== "denied") {
      (window as any).Notification.requestPermission().then(
        (permission: NotificationPermission) => {
          if (permission === "granted") {
            new (window as any).Notification("Hello", {
              body: "You got new scheduling Notification",
            });
          }
        }
      );
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (
        !!error &&
        !error.includes("Network Error") &&
        statusCode !== 401
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      } else {
        dispatchResetError();
      }
    }
  };

  const fetchNotificationCountData = () => {
    dispatchResetError();
    dispatchResetNotificationSuccess();
    dispatchResetNotificationStatusCode();
    dispatchResetNotificationStatusCode();
    const finalData = {
      token,
    };
    dispatchGetSchedulingNotificationCountAction(finalData);
  };

  return (
    <>
      <ButtonDropdown
        isOpen={isOpen}
        toggle={() => {
          setIsOpen(!isOpen);
        }}
      >
        <DropdownToggle
          style={{
            backgroundColor: "white",
            padding: "6px",
            position: "relative",
            marginRight: "10px",
          }}
        >
          <img src={isOpen ? NotificationRedIcon : NotificationGreyIcon} />
          {notificationCount > 0 && (
            <span
              className={
                notificationCount < 100
                  ? "notification-count"
                  : "notification-counts"
              }
            >
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {notificationCount > 0 ? notificationCount : ""}
              </span>
            </span>
          )}
        </DropdownToggle>
        <DropdownMenu right>
          <div
            className="thinScroll"
            style={{ width: "440px", padding: "15px" }}
          >
            <div className="d-flex justify-content-between">
              <h5 className="text-start ">Notifications</h5>
              <span
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
                style={{ cursor: "pointer" }}
              >
                <img src={CloseIcon} alt="" />
              </span>
            </div>
            <hr style={{ marginTop: "0" }} />
            {isOpen && <SchedulingNotification history={history} />}
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      {handleErrorModal()}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.notification.fetching,
  success: state.notification.success,
  error: state.notification.error,
  statusCode: state.notification.statusCode,
  notificationCount: state.notification.notificationCount,
  // notificationCount: state.notification.notificationCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetError: () => dispatch(resetNotificationError()),
  dispatchResetNotificationSuccess: () => dispatch(resetNotificationSuccess()),
  dispatchResetNotificationStatusCode: () =>
    dispatch(resetNotificationStatusCode()),
  dispatchResetScheduleNotificationCount: () =>
    dispatch(resetScheduleNotificationCount()),
  dispatchGetSchedulingNotificationCountAction: (
    data: GetSchedulingNotificationCountPayloadType
  ) => dispatch(getSchedulingNotificationCountAction(data)),
  dispatchResetNotificationCount: () =>dispatch(resetNotificationCount())
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);